import styled from 'styled-components';

export const StyledWholesaleGateModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 8px;

  p {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
  }

  .wholesale-gate-action-btn {
    align-self: center;
    margin-top: 8px;
    background-color: ${({ theme }) => theme.wholesale} !important;
    border-color: ${({ theme }) => theme.wholesale} !important;
    color: ${({ theme }) => theme.white} !important;
  }
`;
